import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
import { GradeType } from '~/onboarding/utils/grade-color.utils'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import Loader from '~/components/Utility/Loader'

import { selectGradeListByCountry } from '../slice/curriculum.slice'
import { useGetUserChosenCurriculumCountryCode } from '../hooks/useGetCurriculumCountryCode'

import { GradeDesign } from './GradeDesign'
import NorwegianAboveTenGradeList from './NorwegianAboveTenGradeList'

export default function GradeList({ className }: { className?: string }): React.ReactElement {
  const router = useRouter()
  const isCurriculumFromSelectGrade = router.query.countryCode

  const countryCode = useGetUserChosenCurriculumCountryCode()
  const gradeList = useAppSelector(selectGradeListByCountry)
  const isNorwegianCurriculum =
    isCurriculumFromSelectGrade === 'grade-no' || countryCode === CurriculumCountryCodes.NORWAY
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.LG })
  const isGradeListValid = Array.isArray(gradeList) && gradeList?.length > 0
  const gradeListLengthSanity = isGradeListValid ? gradeList.length : 0

  const gradeListLength = isNorwegianCurriculum ? 10 : gradeListLengthSanity
  const aboveTenthGradeCount = isDesktop ? gradeListLength % 3 : gradeListLength % 2
  const belowTenthGradeCount = gradeListLength - aboveTenthGradeCount
  let belowTenthGrades: GradeType[] = []
  let aboveTenthGrades: GradeType[] = []

  if (isGradeListValid) {
    belowTenthGrades = gradeList.slice(0, belowTenthGradeCount)
    aboveTenthGrades = gradeList.slice(belowTenthGradeCount, isNorwegianCurriculum ? 10 : gradeListLengthSanity)
  }

  return (
    <Loader className="mx-auto mt-4" color="white" isLoading={Boolean(!gradeList.length)} size="huge">
      <div className={`flex flex-col items-center justify-center ${className ?? ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7 w-full sm360:w-auto">
          {belowTenthGrades.map((grade) => (
            <GradeDesign grade={grade} key={grade._id} />
          ))}
        </div>
        <div
          className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-${
            isNorwegianCurriculum ? aboveTenthGradeCount : 3
          } gap-6`}
        >
          {aboveTenthGrades.map((grade) => (
            <div className="mt-6" key={grade._id}>
              <GradeDesign grade={grade} />
            </div>
          ))}
        </div>
        {isNorwegianCurriculum && (
          <>
            <div className="max-w-full w-80 h-px bg-white mt-4 lg:mt-10 xl:mt-8" />
            <NorwegianAboveTenGradeList />
          </>
        )}
      </div>
    </Loader>
  )
}
